import type { FaireProductEntity } from "../../entity_types/product";

export const p_6ntf568hwg: FaireProductEntity = {
  token: "p_6ntf568hwg",
  type: "product",
  name: "Soft Almond & Pistachio Nougat Covered in Dark Chocolate",
  brandToken: "b_6cjsp5frk5",
  brandName: "Alto Imports Company",
  imageUrl:
    "https://cdn.faire.com/fastly/283b546fc7213dfd18241c588a3f083f45039b3b86790bdcc67559d92fcfba73.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/01c5999b7c0162b3736a21271529255e2092cfd3539b0c20cf55a551b6cf54a7.png",
  ],
  priceDollars: 9.13,
  description:
    "Fratelli Sicilia Soft Almond & Pistachio Nougat is a classic Italian torrone morbido, crafted with premium almonds and pistachios for a tender, chewy texture. The nougat is finished with a smooth coating of dark chocolate, adding depth and elegance to every bite.\n\nMade in Sicily using traditional confectionery techniques, this bar is ideal for gourmet retailers, Italian specialty stores, gift assortments, and premium chocolate displays.",
  tags: [],
  msrpDollars: 18.26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:48:48.243Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
